<template>
  <div class="horse-list">
    <div class="horse-list__header">
      <h3>Horse List (1- {{ horses.length }})</h3>
    </div>
    <div class="horse-list__table-wrapper">
      <table class="horse-list__table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Condition</th>
            <th>Color</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="horse in horses" :key="horse.id">
            <td>{{ horse.name }}</td>
            <td>{{ horse.condition }}</td>
            <td>
              <span 
                class="color-badge" 
                :style="{ backgroundColor: horse.color.hex }"
              >
                {{ horse.color.name }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'HorseList',
  setup() {
    const store = useStore();
    
    const horses = computed(() => store.getters['horses/allHorses']);
    
    return {
      horses
    };
  }
};
</script>

<style scoped>
.horse-list {
  background-color: var(--color-bg-card);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  border: 1px solid var(--color-border);
}

.horse-list__header {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  padding: var(--space-4) var(--space-5);
  flex-shrink: 0;
}

.horse-list__header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.01em;
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.horse-list__header h3::before {
  content: '📋';
  font-size: 16px;
}

.horse-list__table-wrapper {
  flex: 1;
  overflow-y: auto;
}

.horse-list__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.horse-list__table th,
.horse-list__table td {
  padding: var(--space-3) var(--space-3);
  text-align: center;
}

.horse-list__table th {
  background-color: var(--color-border-light);
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-secondary);
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: 1px solid var(--color-border);
}

.horse-list__table tbody tr {
  border-bottom: 1px solid var(--color-border-light);
  transition: background-color 0.15s ease;
}

.horse-list__table tbody tr:hover {
  background-color: var(--color-border-light);
}

.horse-list__table tbody tr:last-child {
  border-bottom: none;
}

.horse-list__table td {
  color: var(--color-text);
}

.color-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-sm);
  color: white;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  min-width: 50px;
}
</style>
